import AgoraGetStarted from '../agora_manager/agora_manager_get_started.js';
import FirebaseService from './FirebaseService.js'

/**
 * Serviço para gerenciar interações com o Agora SDK.
 */
class AgoraService {
  /**
   * Construtor da classe AgoraService.
   * Inicializa as propriedades e chama a função de inicialização.
   */
  constructor() {
    console.log('CONSTRUCT AgoraService');
    this.agoraAppID = '61cf3781778b4a15a3460bd5ab7814bb';
    this.AgoraGetStarted = null;
    this.remotePlayerContainer = null;
    this.localPlayerContainer = null;

    this.videoOn = true;
    this.audioOn = true;
    this.blurOn = true;

    this.channelParameters = {
      localAudioTrack: null,
      localVideoTrack: null,
      remoteAudioTrack: null,
      remoteVideoTrack: null,
      remoteUid: null
    };

    this.objRoomAgora = null;

    this.FirebaseService = new FirebaseService()
    this.joinParameters = null

    this.initialize();
  }

  /**
   * Inicializa os contêineres de vídeo para o streaming local e remoto.
   */
  async initialize() {
    this.remotePlayerContainer = document.createElement('div');
    this.localPlayerContainer = document.createElement('div');
  }

  /**
   * Entra na sala do Agora com base no payload e CPF fornecidos.
   * @param {Object} payload - Dados do payload que contém informações sobre a sala.
   * @param {string} cpf - CPF do paciente.
   */
  async enterRoom(payload, cpf, funId) {
    this.objRoomAgora = {
      room: payload.canal,
      token: payload.token,
      uid: payload.uid
    };

    this.joinParameters = {
      appId: this.agoraAppID,
      channelName: payload.canal,
      token: payload.token,
      pacCpf: cpf,
      funId: funId
    };
    const localStreamDiv = document.getElementById('local_stream');

    this.remotePlayerContainer = document.createElement("div");
    this.localPlayerContainer = document.createElement("div");
    this.AgoraGetStarted = await AgoraGetStarted(this.handleEvents.bind(this));

    await this.AgoraGetStarted.join(
      localStreamDiv, this.localPlayerContainer, 
      this.channelParameters, this.joinParameters
    );
  }

  /**
   * Manipula eventos recebidos do Agora SDK.
   * @param {string} eventName - Nome do evento.
   * @param {...any} args - Argumentos associados ao evento.
   */
  handleEvents = (eventName, ...args) => {
    switch (eventName) {
      case "user-published":
        if (args[1] === "video") {
          const remoteUid = args[0].uid.toString();
          this.channelParameters.remoteVideoTrack = args[0].videoTrack;
          this.channelParameters.remoteAudioTrack = args[0].audioTrack;
          this.channelParameters.remoteUid = remoteUid;
          console.warn('USER PUBLISHED', args[0]);
          this.remotePlayerContainer.id = remoteUid;
          this.remotePlayerContainer.style.minWidth = '84vw';
          document.getElementById('expand_stream').appendChild(this.remotePlayerContainer);
          this.channelParameters.remoteVideoTrack.play(this.remotePlayerContainer);
        }
        if (args[1] === "audio") {
          this.channelParameters.remoteAudioTrack = args[0].audioTrack;
          this.channelParameters.remoteAudioTrack.play();
        }
        break;
      case "user-unpublished":
        console.warn('user-unpublished');
        const value = null
        const cpf = this.joinParameters.pacCpf
        this.FirebaseService.updateFirebaseRoom(cpf, 'pacStreamId', value)
        break;
    }
  }

  /**
   * Sai da sala do Agora e remove os elementos de vídeo.
   */
  async leaveRoom() {
    console.warn('LEAVE ROOM', this.channelParameters.localVideoTrack);
    if (!this.channelParameters.localVideoTrack) {
      console.warn('Sem localVideoTrack');
      return;
    }
    await this.AgoraGetStarted.leave(this.channelParameters);
    this._removeView(`local_video`);

    if (this.remotePlayerContainer?.id) {
      this._removeView(this.remotePlayerContainer.id);
    }
  }

  /**
   * Alterna o estado do vídeo local (ligado/desligado).
   * @param {function} callback - Função de retorno chamada com o status do vídeo.
   */
  videoOnOff(callback) {
    if (this.videoOn) {
      this.videoOn = false;
      this.channelParameters.localVideoTrack.setMuted(true);
    } else {
      this.videoOn = true;
      this.channelParameters.localVideoTrack.setMuted(false);
    }
    const obj = {
      status: this.videoOn
    };
    callback(obj);
  }

  /**
   * Alterna o estado do áudio local (ligado/desligado).
   * @param {function} callback - Função de retorno chamada com o status do áudio.
   */
  audioOnOff(callback) {
    if (this.audioOn) {
      this.audioOn = false;
      this.channelParameters.localAudioTrack.setMuted(true);
    } else {
      this.audioOn = true;
      this.channelParameters.localAudioTrack.setMuted(false);
    }
    const obj = {
      status: this.audioOn
    };
    callback(obj);
  }

  /**
   * Alterna o estado do desfoque de fundo (ligado/desligado).
   * @param {function} callback - Função de retorno chamada com o status do desfoque.
   */
  async blurOnOff(callback) {
    if (this.blurOn) {
      this.blurOn = false;
      await this.AgoraGetStarted.disableBackground(this.channelParameters);
    } else {
      this.blurOn = true;
      await this.AgoraGetStarted.setBackgroundColor(this.channelParameters);
    }
    const obj = {
      status: this.blurOn
    };
    callback(obj);
  }

  /**
   * Remove um elemento de visualização com base no ID fornecido.
   * @param {string} id - ID do elemento a ser removido.
   * @private
   */
  _removeView(id) {
    console.warn("Removing " + id + "Div");
    const div = document.getElementById(id);
    if (div) {
      div.remove();
    }
  }
}

export default AgoraService;